import { render, staticRenderFns } from "./setSelect.vue?vue&type=template&id=f0b8b522&scoped=true&"
import script from "./setSelect.vue?vue&type=script&lang=js&"
export * from "./setSelect.vue?vue&type=script&lang=js&"
import style0 from "./setSelect.vue?vue&type=style&index=0&id=f0b8b522&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0b8b522",
  null
  
)

export default component.exports